import { ACTION_FORMATS, ACTION_TYPES } from '../interface/custom-types'
import { ActionIconsColors } from '../interface/TAction'

export const getActionIcon = (format: ACTION_FORMATS) => {
  const actionType = ACTION_TYPES.find((item) => item.style === format)
  return actionType?.icon || 'kbase kbase-info-alt'
}

export const getActionIconColor = (format: ACTION_FORMATS) => {
  const actionColorStyle = ActionIconsColors.find((item) => item.format === format)
  return actionColorStyle?.value || ''
}
